import { EmQuestionSetReview } from './EmQuestionSetReview';
import { connect } from 'react-redux';
import {
  getExam,
  getExamLoadingStatus,
  getQuestion,
  getSolution,
  getClassQuestionResponses,
  loadClassQuestionResponses,
  loadExam,
  loadExamSolution,
  getSensibleInstructionTextForQuestionId,
  STATUS,
} from 'edrolo/domains/exams';
import { STATUS as questionSetReviewStatus } from '../constants';

const mapStateToProps = (
  state,
  { examId, questionId, classId, searchParams, topicId }
) => {
  const status = getExamLoadingStatus(state, examId);
  const examStatusKey = Object.entries(STATUS).filter(
    ([key, value]) => status === value
  )[0][0];
  const examStatusValue = questionSetReviewStatus[examStatusKey];

  return {
    exam: getExam(state, examId),
    examStatus: examStatusValue,
    question: getQuestion(state, questionId),
    solution: getSolution(state, questionId),
    responses: getClassQuestionResponses(state, classId, examId, questionId),
    examId,
    questionId,
    classId,
    topicId,
    getQuestionInstructionText: (questionId) =>
      getSensibleInstructionTextForQuestionId(state, questionId),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadExam: (examId) => dispatch(loadExam.signal(examId)),
  loadExamSolution: (examId) => dispatch(loadExamSolution.signal(examId)),
  loadClassQuestionResponses: (classId, examId, questionId) =>
    dispatch(loadClassQuestionResponses.signal(classId, examId, questionId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmQuestionSetReview);
